import { BaseRequest } from "../../../base/request/BaseRequest";
import { toISODate } from "../../../utils/fechaUtils";

/** Request de `POST /fertilizacion/parse`: descarga el Excel ya subido a Azure,
 *  lo parsea con el microservicio y guarda el análisis resultante. */
export type FertilizacionParseRequest = BaseRequest & {
  /** Finca del análisis. */
  fincaId: string;
  /** URL del blob (sin SAS token) donde el cliente subió el Excel. `null` hasta
   *  que la subida termina (el form no deja procesar sin archivo). */
  blobUrl: string | null;
  /** Fecha del análisis (ISO date), la que ingresa el usuario. */
  fechaAnalisis: string;
};

/** Crea un request de parse vacío para la finca (fecha = hoy, sin archivo). */
export const fx_createFertilizacionParseRequestEmpty = (
  fincaId: string,
): FertilizacionParseRequest => {
  return {
    fincaId,
    blobUrl: null,
    fechaAnalisis: toISODate(new Date()),
  };
};
